import React, { useState, useEffect } from "react";
import { useParams, useHistory } from "react-router-dom";
import Swal from "sweetalert2";
import api from "../../Axios";

const UpdateReligion = () => {
  const { id } = useParams();
  const history = useHistory();

  const raasiList = [
    "Mesham",
    "Rishabam",
    "Midhunam",
    "Kadagam",
    "Simmam",
    "Kanni",
    "Thulam",
    "Viruchigam",
    "Dhanus",
    "Magaram",
    "Kumbam",
    "Meenam",
  ];

  const starList = [
    "ashwini",
    "barani",
    "krithikai",
    "rohini",
    "mirugasiridam",
    "thiruvadhirai",
    "punarpoosam",
    "poosam",
    "ayilyam",
    "magam",
    "pooram",
    "uthiram",
    "astham",
    "chithirai",
    "swathi",
    "visagam",
    "anusham",
    "kettai",
    "mulam",
    "puradam",
    "uthiradam",
    "thiruvonam",
    "avittam",
    "sadayam",
    "purattadhi",
    "uttrttadhi",
    "revathi",
  ];

  const dhosamList = [
    "No Dhosam",
    "Chevvai Dhosam",
    "Rahu Dhosam",
    "Kethu Dhosam",
    "Kalathra Dhosam",
    "Kala Sarpa Dhosam",
    "Naga Dosham",
    "Don't Know",
  ];

  const kulamList = [
    "Payidikutthaluvaru",
    "Rama jallivaru",
    "Bomma jallivaru",
    "Mamidikuntaluvaru",
    "Entavaru",
    "Entaluvaru",
    "Engiti aaguluvaru",
    "Eeraluvaru",
    "Beerahavaru",
    "Eramavaru",
    "Etthulu Thantavaru",
    "Sutravaru",
    "Jallivaru",
    "Janavaru",
    "Jitthaluvaru",
    "Kachchavaru",
    "Kannadivaru",
    "Kurukunjaluvaru",
    "Kuntavaru",
    "Kuntamukkavaru",
    "Kodavaru",
    "Kothaluvaru",
    "Kotangivaru",
    "Kommuvaru",
    "Kejjaluvaru",
    "Kommuluvaru",
    "Mangavaru",
    "Machchaluvaru",
    "Mudikiluvaru",
    "Maithulavaru",
    "Nallamullavaru",
    "Nelliyamvaru",
    "Pannavaru",
    "Pandhivaru",
    "Paravaru",
    "Pallavaru",
    "Pantivaru",
    "Parvaivaru",
    "Pachchiluvaru",
    "Patamasalavaru",
    "Pittavaru",
    "Puliputthaluvaru",
    "Boothivaru",
    "Peguluvaru",
    "Bodhuvaru",
    "Soothaluvaru",
    "Santhavaru",
    "Settiselvaru",
    "Dhasarivaru",
    "Dhommaluvaru",
    "Dhoothaluvaruu",
    "Vejivaru",
    "Dheiyaluvaru",
    "Dhogaluvaru",
    "Koolivaru",
    "Sembootthuluvaru",
    "Karavaru",
    "Kobaluvaru",
    "Sullivaru",
    "Other",
  ];

  const [formData, setFormData] = useState({
    caste: "",
    gothram: "",
    zodiac: "",
    star: "",
    raasi: "",
    dhosam: "",
  });

  useEffect(() => {
    if (id) {
      api
        .get(`/admin/userProfile/profileView?userId=${id}`)
        .then((res) => {
          const d =
            res.data && res.data.data.horoscope ? res.data.data.horoscope : {};
          setFormData({
            caste: d.caste || "",
            gothram: d.gothram || "",
            zodiac: d.zodiac || "",
            star: d.star || "",
            raasi: d.raasi || "",
            dhosam: d.dhosam || "",
          });
        })
        .catch(() => {
          Swal.fire("Error", "Failed to load religion details", "error");
        });
    }
  }, [id]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    api
      .post(`/admin/userProfile/religiousUpdate/`, {
        userId: Number(id),
        ...formData,
      })
      .then(() => {
        Swal.fire("Success", "Religion details updated", "success").then(() =>
          history.goBack()
        );
      })
      .catch(() => {
        Swal.fire("Error", "Failed to update religion details", "error");
      });
  };

  return (
    <div style={{ maxWidth: "600px", margin: "100px" }}>
      <h2>Edit Religion Details</h2>
      <form onSubmit={handleSubmit}>
        {/* Caste from kulamList */}
        {/* <div style={{ marginBottom: "15px" }}>
          <label>Caste</label>
          <select
            name="caste"
            value={formData.caste}
            onChange={handleChange}
            style={{ width: "100%", padding: "8px" }}
          >
            <option value="">Select Caste</option>
            {kulamList.map((item, idx) => (
              <option key={idx} value={item}>
                {item}
              </option>
            ))}
          </select>
        </div> */}

        {/* Gothram text */}
        {/* <div style={{ marginBottom: "15px" }}>
          <label>Gothram</label>
          <input
            type="text"
            name="gothram"
            value={formData.gothram}
            onChange={handleChange}
            style={{ width: "100%", padding: "8px" }}
          />
        </div> */}

        {/* Zodiac text */}
        {/* <div style={{ marginBottom: "15px" }}>
          <label>Zodiac</label>
          <input
            type="text"
            name="zodiac"
            value={formData.zodiac}
            onChange={handleChange}
            style={{ width: "100%", padding: "8px" }}
          />
        </div> */}

        {/* Star from starList */}
        <div style={{ marginBottom: "15px" }}>
          <label>Star</label>
          <select
            name="star"
            value={formData.star}
            onChange={handleChange}
            style={{ width: "100%", padding: "8px" }}
          >
            <option value="">Select Star</option>
            {starList.map((item, idx) => (
              <option key={idx} value={item}>
                {item}
              </option>
            ))}
          </select>
        </div>

        {/* Raasi from raasiList */}
        <div style={{ marginBottom: "15px" }}>
          <label>Raasi</label>
          <select
            name="raasi"
            value={formData.raasi}
            onChange={handleChange}
            style={{ width: "100%", padding: "8px" }}
          >
            <option value="">Select Raasi</option>
            {raasiList.map((item, idx) => (
              <option key={idx} value={item}>
                {item}
              </option>
            ))}
          </select>
        </div>

        {/* Dhosam from dhosamList */}
        <div style={{ marginBottom: "15px" }}>
          <label>Dhosam</label>
          <select
            name="dhosam"
            value={formData.dhosam}
            onChange={handleChange}
            style={{ width: "100%", padding: "8px" }}
          >
            <option value="">Select Dhosam</option>
            {dhosamList.map((item, idx) => (
              <option key={idx} value={item}>
                {item}
              </option>
            ))}
          </select>
        </div>

        <button
          type="submit"
          style={{
            background: "black",
            color: "white",
            padding: "10px 20px",
            border: "none",
          }}
        >
          Save
        </button>
      </form>
    </div>
  );
};

export default UpdateReligion;
